<template>
    <div class="relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 shadow-md">
        <div
            class="relative h-full bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr shadow-lg mt-6"
            :class="cClass"
            style="min-height: 180px">
            <slot>
                <hts-analytics-chart
                    :type="type"
                    :labels="labels"
                    :series="series"
                    :width="width"
                    :height="height"
                    :fore-color="chartForeColor"
                    :fill-color="chartFillColor"
                    :bg-color="chartBgColor"
                    class-name="min-h-full" />
            </slot>
        </div>
        <div class="p-6">
            <h6 class="block antialiased tracking-normal font-sans text-base font-semibold leading-relaxed text-blue-gray-900">
                {{ title }}
            </h6>
            <p class="block antialiased font-sans text-sm leading-normal font-normal text-blue-gray-600">
                {{ description }}
            </p>
        </div>
        <slot name="hint" />
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
  color: String,
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'bar'
  },
  labels: Array,
  series: Array,
  value: [String, Number],
  width: String,
  height: String,
  foreColor: String,
  fillColor: String
})
const { color, foreColor, fillColor } = toRefs(props)

const cClass = computed(() => {
  switch (color?.value) {
  case 'success':
    return 'from-green-600 to-green-400 text-white shadow-green-500/40'
  case 'error':
    return 'from-pink-600 to-pink-400 text-white shadow-pink-500/40'
  default:
    return 'from-blue-600 to-blue-400 text-white shadow-blue-500/40'
  }
})
const chartForeColor = computed(() => {
  return foreColor?.value || '#FFF'
})
const chartFillColor = computed(() => {
  return fillColor?.value || '#FFF'
})
const chartBgColor = computed(() => {
  switch (color?.value) {
  case 'success':
    return '#16a34a'
  case 'error':
    return '#db2777'
  default:
    return '#2563eb'
  }
})
</script>
